// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-control {\n  max-width: 14rem;\n}\n.searchbar-width .tags-input-wrapper-default {\n  min-width: 20rem;\n}\n.search-header-sticky-top {\n  position: sticky;\n  top: 62px;\n  z-index: 10;\n}\n", ""]);
// Exports
module.exports = exports;
